export default __webpack_public_path__ + "static/media/IconDesc_ReinforcedIronPlates.256.1df0d16d.png";